import styled from 'styled-components'

interface NftGridProps {
  isHomeView: boolean
}

const NftGrid = styled.div<NftGridProps>`
  display: grid;
  grid-gap: 32px;
  grid-template-columns: 1fr;
  padding-bottom: 24px;
  padding-top: 24px;

  ${({ theme }) => theme.mediaQueries.sm} {
    grid-template-columns: repeat(${({ isHomeView }) => (isHomeView ? 1 : 2)}, 1fr);
  }

  ${({ theme }) => theme.mediaQueries.md} {
    grid-template-columns: repeat(${({ isHomeView }) => (isHomeView ? 1 : 3)}, 1fr);
  }

  ${({ theme }) => theme.mediaQueries.lg} {
    grid-template-columns: repeat(${({ isHomeView }) => (isHomeView ? 3 : 4)}, 1fr);
  }
`

export default NftGrid
